import '@carvana/showroom-forms/Checkbox/index.css'; // TODO: Move these higher in the tree so we always have them
import '@carvana/showroom-forms/Slider/index.css';
import cx from 'classnames';
import useGetFilterTags from '@/MainLayout/useGetFilterTags';
import MenuOption from '~/constants/MenuOption';
import BedLength from './BedLength';
import BodyType from './BodyType';
import CabTypes from './CabTypes';
import ColorFacet from './Colors/ColorFacet';
import Cylinders from './Cylinders';
import Features from './Features';
import GreatDeals from './GreatDeals/GreatDeals';
import MakeModel from './MakeModel';
import MPG from './MPG';
import PaymentAndPrice from './PaymentAndPrice';
import SeatingCapacity from './SeatingCapacity';
import SimpleCheckboxList from './SimpleCheckboxList';
import Size from './Size';
import TowingCapacity from './TowingCapacity';
import Trim from './Trim';
import YearAndMileage from './YearAndMileage';

type OwnProps = {
  expandOnOpen?: MenuOption;
};

export default function FiltersMenu({ expandOnOpen }: OwnProps) {
  const filterTags = useGetFilterTags();
  const hasFilterTags = filterTags.length > 0;

  return (
    <>
      <div
        className={cx('bg-white l:rounded-md', {
          'rounded-t-none': hasFilterTags
        })}
        data-qa="standardized-filters-menu"
      >
        <PaymentAndPrice
          expandOnOpen={expandOnOpen}
          className={cx({
            'border-t-0 l:rounded-t-md': !hasFilterTags
          })}
        />
        <MakeModel expandOnOpen={expandOnOpen} />
        <Trim />
        <BodyType expandOnOpen={expandOnOpen} />
        <Size />
        <BedLength />
        <CabTypes />
        <TowingCapacity />
        <YearAndMileage />
        <GreatDeals />
        <SimpleCheckboxList title="Fuel" filterKey="fuelTypes" />
        <MPG />
        <Features />
        <ColorFacet facetKey="colors" />
        <ColorFacet facetKey="interiorColors" />
        <SeatingCapacity />
        <SimpleCheckboxList
          checkboxClassName="uppercase"
          title="Drivetrains"
          filterKey="driveTypes"
        />
        <SimpleCheckboxList title="Transmissions " filterKey="transmissions" />
        <Cylinders />
      </div>
    </>
  );
}
